import { defaultLocale } from '@atlassian/jira-common-constants/src/supported-locales.tsx';
import { toProjectId, toProjectKey } from '@atlassian/jira-shared-types/src/general.tsx';
import type { AppPropsState } from '../../../model/app-props/types.tsx';
import { SET_APP_PROPS, type SetAppPropsAction } from '../../actions/app-props/index.tsx';

type Action = SetAppPropsAction;

export const initialState = {
	locale: defaultLocale,
	projectId: toProjectId('-1'),
	projectKey: toProjectKey(''),
	environment: 'prod',
	isProjectAdmin: false,
	isProjectSimplified: false,
	isJSMChatInstalled: false,
} as const;

// eslint-disable-next-line jira/import/no-anonymous-default-export
export default (state: AppPropsState = initialState, action: Action): AppPropsState => {
	switch (action.type) {
		case SET_APP_PROPS:
			return action.payload;
		default: {
			const _exhaustiveCheck: never = action.type;
			return state;
		}
	}
};
